
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import Routes from '@/Routes';
import { Organization } from '@/models/Organization';

@Component({
  components: {
   
  },
})
export default class OrganizationPage extends Vue {

  get routeName(){
    return this.$route.name;
  }

  get organizations(): Organization[] {
    return this.$store.state.organization.organizations;
  }

  get routeOrganizationId(): string {
    return this.$store.state.route.params.organizationId;
  }

  get navigationRoutes(): any[] {
    const organizationRoot = (this.$router as any).options.routes
      .find((r: any) => r.meta && r.meta.organizationRoot) as RouteConfig;
    
    if (!organizationRoot) {
      return [];
    }
    const navRoutes = organizationRoot.children.map(c => c).filter(c => c.meta && c.meta.organizationNav);
    return navRoutes;
  }

   async redirectToFirstNavigationRoute(alreadyRedirected: boolean = false){
    try {
      if (this.$route.name === Routes.organizationRoute.name){
        this.$router.replace(
          {
            name: this.navigationRoutes[0].name
          }
        );
      }
    } catch (err) {

      if (this.routeOrganizationId === '' && this.organizations.length > 0 && !alreadyRedirected){
        const firstOrganizationId = this.organizations[0].id;

        await this.$router.replace({
            name: Routes.organizationRoute.name,
            params: { 
                organizationId: firstOrganizationId.toString(),
            }
        });

        await this.redirectToFirstNavigationRoute(true);

      } else {
        throw err;
      }
    }
  }

  created(){
    this.redirectToFirstNavigationRoute();
  }

  @Watch('routeName', { immediate: false })
  onRouteNameChanged(val, newVal){
    this.redirectToFirstNavigationRoute();
  }

}
